var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3273_6968)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3273_6968",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3273_6968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26342 10.291C7.26342 9.35684 6.50748 8.6009 5.5733 8.6009",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2678 10.291C17.2678 9.35684 18.0238 8.6009 18.9579 8.6009",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2678 3.15168C17.2678 4.08586 18.0238 4.8418 18.9579 4.8418",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2656 3.12434H18.3506C18.7006 3.12434 18.9844 3.40809 18.9844 3.75813V9.68262C18.9844 10.0327 18.7006 10.3164 18.3506 10.3164H14.0234",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5078 10.3164H6.18066C5.83066 10.3164 5.54688 10.0327 5.54688 9.68262V6.29066",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5839 5.83551C10.9029 5.23285 11.5363 4.82223 12.2656 4.82223C13.3157 4.82223 14.167 5.67352 14.167 6.72359C14.167 7.77371 13.3157 8.625 12.2656 8.625C11.4602 8.625 10.7718 8.12426 10.4946 7.41711",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82812 1.01633H9.49242C10.0487 1.01633 10.5893 1.20055 11.0298 1.54024L13.0859 3.12571H8.83824C8.39039 3.12571 8.02734 3.48876 8.02734 3.93661C8.02734 4.23165 8.18762 4.50341 8.44578 4.64618L10.4555 5.75766C10.8721 5.98809 11.0574 6.48887 10.891 6.93501C10.7292 7.36868 10.2814 7.62551 9.82547 7.54626L8.41441 7.3009C7.10027 7.07239 5.85371 6.55348 4.76562 5.78196H3.82812",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82812 6.64062H0.390625V0.390626H3.82812V6.64062Z",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1689 19.1406H8.51618C7.16274 19.1406 5.86473 18.603 4.9077 17.6459L2.78555 15.5238C2.40567 15.1439 2.40712 14.5275 2.7888 14.1494C3.16798 13.7737 3.7795 13.7752 4.15688 14.1527L6.05579 16.0521C6.6922 16.6887 7.5554 17.0463 8.45552 17.0463H10.5657",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8718 17.0469H8.6182C8.08417 17.0469 7.65125 16.6139 7.65125 16.0799C7.65125 15.5459 8.08417 15.1129 8.6182 15.1129H11.0845L11.5947 14.5073C12.2295 13.7538 13.1646 13.3189 14.1499 13.3189C14.8548 13.3189 15.5416 13.5418 16.1121 13.9558L16.1689 13.997",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6094 19.6094H16.1719V13.3594H19.6094V19.6094Z",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3273_6968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.50dc785a19235ce278c16c9c9b552ef6.svg";
export { ForwardRef as ReactComponent };